import React from "react";
import * as S from "./styles";

const TermsPrivacyCard: React.FC = () => {
  return (
    <S.WrapperProposal style={{ overflow: "auto" }}>
      <S.Title>
        <b>AVISO DE PRIVACIDADE</b>
      </S.Title>
      <S.Text>
        <p>
          O TeuCard respeita a privacidade, a proteção de dados e o seu
          tratamento de forma transparente, ética, segura e responsável são
          valores essenciais para nós.
        </p>
        <p>
          Este Aviso de Privacidade foi criado para demonstrar o nosso
          compromisso com estes valores, esclarecendo as condições gerais de
          coleta, uso, armazenamento, proteção e demais formas de tratamento de
          dados pessoais para o desempenho de nossas atividades, tanto em
          ambientes online (Site e Aplicativo) quanto off-line (lojas físicas).
        </p>
        <p>
          Ao fornecer os seus dados pessoais ao TeuCard, você aceita os termos e
          condições deste Aviso de Privacidade.
        </p>
        <p>
          <strong>Dados Pessoais </strong>
          são quaisquer informações que podemos utilizar para identificá-lo,
          localizá-lo ou contactá-lo, juntamente com outras informações
          associadas. Também incluem outras informações que possam estar
          associadas às suas Informações Pessoais. Recolhemos vários tipos de
          informações pessoais, incluindo:
        </p>
        <p>
          <strong>Dados de transações realizadas com o cartão </strong>
          que nos permitem fornecer serviços de pagamento. Quando você utiliza o
          cartão TeuCard ou outro produto de pagamento, recebemos a data, hora,
          localização e montante da transação, bem como informações sobre o
          comerciante. Podemos receber outras informações financeiras ao
          processar transações e fornecer serviços aos nossos clientes. Também
          podemos recolher informações adicionais sobre o cartão de pagamento
          que você utiliza, como por exemplo, a respetiva data de validade e
          código de segurança (por ex., o CVV do seu cartão), bem como o seu
          endereço de cobrança);
        </p>
        <p>
          <strong>Informações de Contato </strong>
          que nos permitem comunicar com você, como o seu nome, nome de
          utilizador, endereço, número de telefone, endereço de e-mail ou nomes
          de perfis nas redes sociais;
        </p>
        <p>
          <strong>Informações de Relacionamento </strong>
          que nos ajudam a fazer negócios com você, para tanto, coletamos suas
          preferências de compras e de pagamento, que nos ajudem a compreender
          seus interesses e oferecer-lhe conteúdos personalizados;
        </p>
        <p>
          <strong>Informações de interações com o TeuCard</strong>, quando você:
        </p>
        <p>
          Utiliza os nossos produtos, serviços, websites ou aplicações,
          incluindo informações recolhidas através de Cookies e outras
          tecnologias que podem incluir informações de geolocalização, histórico
          de navegação e outras informações disponíveis através de interações
          digitais;
        </p>
        <p>
          Se comunica conosco, como quando entra em contato com os nossos
          serviços de apoio ao cliente, incluindo a gravação das chamadas por
          motivos de qualidade e para fins de segurança;
        </p>
        <p>
          Participa em promoções ou programas.
          <p>
            {" "}
            - Adere ao TeuClub - Clube de vantagens
            (https://www.clubeteucard.com/) relacionado ao CARTÃO TeuCard.
          </p>
          <br />
          <strong>1. FINALIDADE DA COLETA DOS DADOS PESSOAIS </strong>
        </p>
        <p>
          1.1. O TeuCard realiza o tratamento de dados pessoais de acordo com os
          princípios e bases legais previstas na Lei Geral de Proteção de Dados
          (LGPD).
        </p>
        <p>
          1.2. Apresentamos a seguir diversas finalidades para as quais tratamos
          seus dados pessoais:
        </p>
        <p>
          a) garantir a eficácia e qualidade na prestação dos nossos serviços,
          oferecimento dos produtos contratados e no atendimento aos titulares,
          disponibilizado produtos e serviços mais aderentes ao perfil de cada
          cliente;
        </p>
        <p>
          b) identificação, autenticação e verificação dos requisitos para
          contratação dos serviços e produtos do TeuCard;
        </p>
        <p>
          c) analisar e conceder crédito aos titulares, consultar suas
          informações na base de dados do Sistema de Informações de Crédito
          (SCR);
        </p>
        <p>
          d) monitorar, analisar as tendências, medir audiências, corrigir
          problemas e evoluir o uso do nosso site e aplicativos;
        </p>
        <p>
          <br />
          e) responder a dúvidas, solicitações, reclamações, elogios, e para
          estabelecer comunicação em geral;
        </p>
        <p>
          f) realizar e manter o seu cadastro atualizado, verificar sua
          identidade e eventuais outras informações;
        </p>
        <p>
          g) autenticar acessos dos Titulares às nossas Aplicações de Internet;
        </p>
        <p>
          <br />
          h) buscar segurança adequada aos serviços oferecidos e meios de
          identificação no caso de usos impróprios ou ilícitos;
        </p>
        <p>
          <br />
          i) resolver dúvidas, problemas e formular notificações relacionadas ao
          uso das nossas Aplicações de Internet;
        </p>
        <p>
          <br />
          j) avaliar a qualidade do atendimento de nossos colaboradores;
        </p>
        <p>
          <br />
          k) manter os titulares informados sobre os serviços, alterações,
          atualizações ou melhorias nas nossas Aplicações de Internet, ou ainda
          sobre o status de suas contas e operações;
        </p>
        <p>
          <br />
          l) manter contato por telefone, e-mail, SMS, WhatsApp ou outros meios
          de comunicação, inclusive para o envio de notificações;
        </p>
        <p>
          <br />
          m) aprimoramento dos serviços prestados pelo TeuCard, inclusive com o
          cruzamento de informações sobre produtos contratados por pessoa física
          ou jurídica para oferecimento de novos produtos e serviços;
        </p>
        <p>
          <br />
          n) marketing, prospeção, pesquisas de mercado, de opinião e promoção
          dos nossos produtos e serviços, ou de nossos parceiros, inclusive com
          viabilização de ofertas e envio de informações sobre produtos,
          serviços, novidades, funcionalidades, conteúdos, notícias e demais
          eventos relevantes para a manutenção do relacionamento com você, desde
          que com consentimento prévio;
        </p>
        <p>
          o) divulgar ações promocionais, propostas personalizadas, recomendação
          de novos serviços, produtos ou funcionalidades do TeuCard ou outras
          iniciativas de publicidade, desde que com consentimento prévio;
        </p>
        <p>
          p) identificar, prevenir e gerenciar eventuais riscos de segurança,
          física ou cibernética, sua, do TeuCard ou de terceiros;
        </p>
        <p>
          <br />
          q) atividades relacionadas à proteção do crédito, como avaliação e
          gerenciamento de risco de crédito, avaliação de situação financeira e
          patrimonial, cobrança, cessão de crédito, atividades relacionadas à
          informação e consulta a entidades de proteção ao crédito e cadastro
          positivo, entre outras.
        </p>
        <p>
          r) realizar cancelamento de compras e estorno de valores, observado o
          disposto na legislação vigente;
        </p>
        <p>
          s) permitir o gerenciamento da Carteira Digital, incluindo os dados de
          pagamentos e utilização do serviço considerando as informações
          bancárias cadastradas (dados dos cartões de débito, crédito para
          realizar pagamento por celular)
        </p>
        <p>
          t) cumprir obrigações legais e regulatórias, e com os contratos
          firmados com os Titulares.
        </p>
        <p>
          u) para o exercício regular de direitos, inclusive em contratos e
          processos judiciais, extrajudiciais, administrativos ou arbitrais.
        </p>
        <p>
          v) permitir a utilização dos benefícios/vantagens disponibilizadas
          pelo TeuClub - Clube de vantagens
        </p>
        <p>
          1.3. Eventualmente, outros tipos de dados não previstos expressamente
          neste Aviso de Privacidade poderão ser coletados, desde que sejam
          fornecidos com o consentimento do usuário, ou, ainda, que a coleta
          seja permitida com fundamento em outra base legal prevista em lei. Em
          qualquer caso, a coleta de dados e as atividades de tratamento dela
          decorrentes serão informadas aos usuários do site.
        </p>
        <p>
          <strong>2. QUAIS INFORMAÇÕES UTILIZAMOS E COMO AS COLETAMOS </strong>
        </p>
        <p>
          2.1. Para atender às finalidades previstas neste Aviso, podemos
          coletar em nossas lojas, em eventos ou em outros ambientes físicos e
          digitais, seus <strong>dados cadastrais </strong>(nome, data de
          nascimento, sexo, RG, CPF e/ou outros documentos de identificação,
          tais como carteira de habilitação, foto, endereço residencial e
          comercial, localidade, telefones residencial, comercial e celular,
          e-mail, profissão, ocupação, estado civil, nacionalidade,
          naturalidade), <strong>dados financeiros e transacionais </strong>
          (renda, patrimônio, negativação, dados do cadastro positivo,
          informações sobre operações e transações bancárias, financeiras e de
          pagamento, produtos e serviços contratados ou que se pretenda
          contratar e sua utilização) e{" "}
          <strong>informações sobre seus dispositivos </strong>(Advertising ID,
          informações técnicas, sistema operacional, tamanho de tela, conexão,
          data, hora, endereço IP, rede utilizada, identificação do dispositivo
          e uso do dispositivo), a partir de informações:
        </p>
        <p>
          a) que você nos fornece, espontaneamente, ao preencher cadastros e
          formulários ou ao responder perguntas de nossos colaboradores, bem
          como ao participar de pesquisas de opinião ou entrevistas;
        </p>
        <p>b) do uso dos nossos serviços.</p>
        <p>
          c) que você cadastra ao concordar em utilizar o serviço da Carteira
          Digital e fazer uso do aplicativo;
        </p>
        <p>
          d) que você preenche ao se cadastrar no TeuClub -Clube de vantagens
          (https://www.clubeteucard.com/).
        </p>
        <p>
          <br />
          2.2. Nossas Aplicações de Internet também podem coletar seus dados
          pessoais a partir de informações:
        </p>
        <p>
          a) que você mesmo nos fornece, espontaneamente, mediante a criação de
          contas ou a inserção de referências a seu respeito em qualquer
          contexto nas nossas Aplicações de Internet;
        </p>
        <p>
          <br />
          b) sobre a forma como você navega e sobre os registros de acesso e de
          interações em geral nas nossas Aplicações de Internet, incluindo
          informações: (i) sobre o dispositivo e os sistemas / navegadores que
          você utiliza para acessar as nossas Aplicações de Internet, incluindo
          o endereço de protocolo de Internet (número IP); (ii) passíveis de
          identificar todo e qualquer uso e interação no contexto das nossas
          Aplicações de Internet, incluindo as suas preferências em geral, os
          serviços que você visualizou ou pesquisou, a duração das suas visitas
          e outras informações de interação com as páginas, como o uso da barra
          de rolagem, cliques, abas e locais por onde você navegou com o mouse;
          (iii) referentes ao momento de cada ação sua nas nossas Aplicações de
          Internet (data e hora); (iv) referentes à sua geolocalização; (v)
          referentes ao site acessado por você imediatamente antes de visitar as
          nossas Aplicações de Internet.
        </p>
        <p>
          c) obtidas por meio de cookies, tags e identificadores anônimos
          contidos em nossos sites e em e-mails enviados a você, usados para
          monitorar suas interações, como, por exemplo, quando você recebeu,
          abriu ou clicou em um link em um e-mail enviado por nós.
        </p>
        <p>
          2.3. Ainda para atender às finalidades previstas na Cláusula 1 acima,
          podemos receber de terceiros seus dados pessoais a partir de
          informações obtidas por:
        </p>
        <p>
          a) outras empresas integrantes do Grupo Nova Era;
          <br />
          b) sites, redes sociais, ferramentas ou plataformas externas
          disponibilizadas por terceiros;
          <br />
          c) empresas de publicidade, pesquisa ou de análise estatística e de
          padrão comportamental (analytics);
          <br />
          d) empresas que organizam bancos de dados;
          <br />
          e) instituições financeiras, de pagamento, de análise de crédito e de
          risco.
        </p>
        <p>
          <strong>3. DADOS SENSÍVEIS </strong>
        </p>
        <p>
          3.1. Não serão coletados dados sensíveis de nossos usuários, assim
          entendidos aqueles definidos no art. 5, II c/c art. 11 da Lei Geral de
          Proteção de Dados Pessoais. Assim, não haverá coleta de dados sobre
          origem racial ou étnica, convicção religiosa, opinião política,
          filiação a sindicato ou a organização de caráter religioso, filosófico
          ou político, dado referente à saúde ou à vida sexual, dado genético,
          quando vinculado a uma pessoa natural.
        </p>
        <p>
          <strong>4. COLETA DE COOKIES </strong>
        </p>
        <p>
          4.1. Definição: cookies são pequenos arquivos de texto baixados
          automaticamente em seu dispositivo quando você acessa e navega por um
          site. Eles servem, basicamente, para seja possível identificar
          dispositivos, atividades e preferências de usuários. Os cookies não
          permitem que qualquer arquivo ou informação sejam extraídos do disco
          rígido do usuário, não sendo possível, ainda, que, por meio deles, se
          tenha acesso a informações pessoais que não tenham partido do usuário
          ou da forma como utiliza os recursos do site.
        </p>
        <p>
          4.2. Cookies do site: são aqueles enviados ao computador ou
          dispositivo do usuário e administrador exclusivamente pelo site. As
          informações coletadas por meio destes cookies são utilizadas para
          melhorar e personalizar a experiência do usuário, sendo que alguns
          cookies podem, por exemplo, ser utilizados para lembrar as
          preferências e escolhas do usuário, bem como para o oferecimento de
          conteúdo personalizado.
        </p>
        <p>
          4.3. Cookies de terceiros: alguns de nossos parceiros podem configurar
          cookies nos dispositivos dos usuários que acessam nosso site. Estes
          cookies, em geral, visam possibilitar que nossos parceiros possam
          oferecer seu conteúdo e seus serviços ao usuário que acessa nosso site
          de forma personalizada, por meio da obtenção de dados de navegação
          extraídos a partir de sua interação com o site. O usuário poderá obter
          mais informações sobre os cookies de terceiro e sobre a forma como os
          dados obtidos a partir dele são tratados, além de ter acesso à
          descrição dos cookies utilizados e de suas características, acessando
          o seguinte link:
        </p>
        <p>
          a) Google Analytics: as entidades encarregadas da coleta dos cookies
          poderão ceder as informações obtidas a terceiros.
          <br />
          b) Gestão de cookies: o usuário poderá se opor ao registro de cookies
          pelo site, bastando que desative esta opção no seu próprio navegador.
          Mais informações sobre como fazer isso em alguns dos principais
          navegadores utilizados hoje podem ser acessadas a partir dos seguintes
          links:
        </p>
        <p>
          b.1) Internet Explorer:
          https://support.microsoft.com/pt-br/help/17442/windows-
          internet-explorer-delete-manage-cookies
          <br />
          b.2) Safari:
          https://support.apple.com/pt-br/guide/safari/sfri11471/mac
          <br />
          b.3) Google Chrome:
          https://support.google.com/chrome/answer/95647?hl=pt- BR&amp;hlrm=pt
        </p>
        <p>
          b.4) Mozila Firefox:
          https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-
          cookies-que-os-sites-usam
          <br />
          b.5) Opera: https://www.opera.com/help/tutorials/security/privacy/
        </p>
        <p>
          4.4. A desativação dos cookies, no entanto, pode afetar a
          disponibilidade de algumas ferramentas e funcionalidades do site,
          comprometendo seu correto e esperado funcionamento. Outra consequência
          possível é remoção das preferências do usuário que eventualmente
          tiverem sido salvas, prejudicando sua experiência.
        </p>
        <p>
          <strong>5. POR QUANTO TEMPO MANTEMOS SEUS DADOS </strong>
        </p>
        <p>
          5.1. Nós trataremos e armazenaremos os seus dados pelo período
          necessário para a finalidade a que foram destinados, incluindo o
          período adicional determinado por lei ou regulação a que nos
          submetemos.
        </p>
        <p>
          5.2. Enquanto você for um Cliente ou Prospecto do TeuCard, durante o
          uso dos nossos produtos e serviços, incluindo a Carteira Digital, e
          por todo o período em que o TeuCard armazenar seus dados pessoais,
          eles serão mantidos em ambiente seguro e controlado.
        </p>
        <p>
          <strong>6. LOCAL ONDE AS INFORMAÇÕES FICAM ARMAZENADAS </strong>
        </p>
        <p>
          6.1. O TeuCard usa diversos tipos de medidas de segurança para
          garantir a integridade de seus dados pessoais, como padrões de
          segurança de informação praticados pela indústria quando coleta e
          armazena dados pessoais.
        </p>
        <p>
          6.2. Os dados pessoais podem, ainda, ser armazenados por meios de
          tecnologia de cloud computing e outras tecnologias que surjam
          futuramente, visando sempre a melhoria e aperfeiçoamento de nossos
          serviços e segurança.
        </p>
        <p>
          <strong>7. COM QUEM COMPARTILHAMOS SEUS DADOS </strong>
        </p>
        <p>
          7.1. O TeuCard somente compartilha suas informações quando é
          necessário ou pertinente para as finalidades previstas nos contratos
          com os nossos clientes e nesse Aviso de Privacidade, tais como:
        </p>
        <p>
          a) entre as empresas do Grupo Nova Era, inclusive para o
          desenvolvimento de nossas atividades, oferta e prestação de serviços e
          fornecimento de produtos, gerenciamento de riscos, cumprimento de
          obrigações legais e demais finalidades previstas nesse Aviso;
        </p>
        <p>
          b) com parceiros estratégicos, inclusive para oferta, contratação e
          uso de produtos e serviços destes, ou ainda desenvolvidos em conjunto
          ou que possam ter um benefício para você;
        </p>
        <p>
          c) com prestadores de serviços, fornecedores, correspondentes e
          parceiros contratados pelo TeuCard para o desenvolvimento de nossas
          atividades;
        </p>
        <p>
          d) com órgãos reguladores, outras entidades públicas, instituições do
          sistema financeiro e terceiros, inclusive para cumprimento e execução
          de obrigações
        </p>
        <p>
          legais, regulatórias, contratuais, para a proteção e o exercício
          regular de direitos;
        </p>
        <p>
          e) são terceiros e parceiros do TeuCard: fornecedores de serviços de
          tecnologia da informação, de atendimento ao consumidor, de
          comunicação, de serviços estatísticos, de pesquisas, marketing,
          serviços financeiros e de meios de pagamentos; parceiros que fabricam,
          personalizam e entregam os nossos cartões, agências de cobrança, de
          crédito e prevenção a fraudes, bancos, instituições financeiras e
          outros terceiros.
        </p>
        <p>
          f) com órgãos reguladores para cumprimento de requisições,
          solicitações e decisões de autoridades judiciais, administrativas ou
          arbitrais;
        </p>
        <p>
          g) com órgãos reguladores para identificação, prevenção e investigação
          de possíveis infrações ou atos ilícitos (inclusive fraude, lavagem de
          dinheiro e financiamento ao terrorismo);
        </p>
        <p>
          h) com plataforma especializada em antifraudes para prevenir riscos,
          fraudes e garantir a segurança em processos de identificação e/ou
          autenticação em sistemas eletrônicos próprios ou de terceiros;
        </p>
        <p>
          i) com bureaus de crédito, inclusive de acordo com o disposto na
          legislação aplicável, como para cumprimento da legislação do cadastro
          positivo, nos casos de negativação, entre outros;
        </p>
        <p>
          j) com outras instituições financeiras, inclusive quando necessário,
          para o processamento de alguma transação ou outras atividades para
          execução de contrato;
        </p>
        <p>
          k) com plataformas online através de compartilhamento de informações
          anonimizadas, agrupadas, de cookies ou de outras informações ou formas
          que não possibilitem a identificação pessoal dos Titulares de Dados;
        </p>
        <p>
          l) com outros interessados desde que com o seu consentimento e neste
          caso, solicitaremos o seu consentimento oportunamente.
        </p>
        <p>
          <strong>8. SEGURANÇA DOS DADOS </strong>
        </p>
        <p>
          8.1. O TeuCard adota medidas de segurança, técnicas e administrativas
          para manter em segurança todos os dados armazenados e garantir a
          preservação da confidencialidade, integridade e disponibilidade dos
          dados, informações e sistemas utilizados.
        </p>
        <p>
          8.2. Estabelecemos processos e controles para prevenção, detecção e
          resposta a incidentes e proteção dos seus dados de acessos e usos não
          autorizados, garantindo a gestão do risco de segurança, inclusive
          cibernética, e a construção de um alicerce robusto de segurança.
        </p>
        <p>
          8.3. Especificamente com relação aos dados coletados através das
          nossas Aplicações de Internet, eles são armazenados, tratados e
          protegidos mediante as melhores práticas de hospedagem, processamento,
          backup e criptografia, de acordo com a sua respectiva criticidade.
        </p>
        <p>
          8.4. Nossos parceiros prestam ao TeuCard garantias contratuais de que
          adotam medidas de segurança técnicas e administrativas aptas a
          proteger seus dados.
        </p>
        <p>
          <strong>9. DIREITOS DOS TITULARES DE DADOS PESSOAIS </strong>
        </p>
        <p>
          9.1. Na forma e nos limites da legislação aplicável, na qualidade de
          titular de dados pessoais, você poderá entrar em contato conosco para
          exercer determinados direitos, de modo a requerer:
        </p>
        <p>
          a) a confirmação da existência de tratamento de seus dados pessoais;
        </p>
        <p>b) o acesso aos seus dados;</p>
        <p>
          c) a correção de seus dados incompletos, inexatos ou desatualizados;
        </p>
        <p>
          d) a anonimização, bloqueio ou eliminação de seus dados que sejam
          desnecessários, excessivos, ou tratados em desconformidade com o
          disposto na legislação aplicável;
        </p>
        <p>
          e) a portabilidade dos seus dados a outro fornecedor de serviço ou
          produto, de acordo com a regulamentação da ANPD, observados os
          segredos comercial e industrial;
        </p>
        <p>
          f) a eliminação dos seus dados pessoais, exceto nas hipóteses
          previstas na legislação aplicável;
        </p>
        <p>
          g) informação das entidades públicas e privadas com as quais o TeuCard
          compartilhou seus dados;
        </p>
        <p>
          h) informação sobre a possibilidade de você não fornecer consentimento
          e sobre as consequências da sua negativa;
        </p>
        <p>
          i) a revogação do seu consentimento, quando você tiver nos fornecido,
          resguardado o interesse público que possa justificar a continuidade do
          tratamento ou a existência de outra base legal que autorize;
        </p>
        <p>
          j) oposição a qualquer tratamento de dados pessoais com fundamento em
          uma das hipóteses em que seu consentimento é dispensado, desde que
          tenha ocorrido o descumprimento ao disposto na legislação aplicável e
          resguardado o interesse público que possa justificar a continuidade do
          tratamento; e
        </p>
        <p>
          k) solicitar a revisão de decisões tomadas unicamente com base em
          tratamento automatizado de dados pessoais que afetem seus interesses.
        </p>
        <p>
          <strong>10. COMO ENTRAR EM CONTATO COM O TEUCARD </strong>
        </p>
        <p>
          10.1. Para exercer seus direitos sobre os seus Dados Pessoais, você
          pode acionar os nossos canais de atendimento nas lojas físicas e
          também por:
        </p>
        <p>a) E-mail: sac@useteucard.com.br</p>
        <p>
          b) Site: https://useteucard.com.br/ - através do “Atendimento Online”
          e/ou Formulário “Fale Conosco”.
        </p>
        <p>
          10.2. Analisaremos seu pedido e o atenderemos com a maior brevidade
          possível, considerando os prazos e os termos previstos na legislação
          aplicável.
        </p>
        <p>
          <strong>11. DIREITO DE APRESENTAR UMA RECLAMAÇÃO </strong>
        </p>
        <p>
          11.1. Caso considere que o processamento de suas informações pessoais
          realizado pelo TeuCard não é compatível com a Lei Geral de Proteção de
        </p>
        <p>Dados Pessoais (LGPD), é possível apresentar uma reclamação:</p>
        <p>
          a) Diretamente para o TeuCard por meio dos canais de atendimento
          informados neste documento;
        </p>
        <p>
          b) Para a ANPD - Autoridade Nacional de Proteção de Dados, caso não
          ocorra resposta de uma demanda feita ao TeuCard.
        </p>
        <p>
          <strong>12. ALTERAÇÕES DESTE AVISO </strong>
        </p>
        <p>
          12.1. Este Aviso de Privacidade pode ser alterado a qualquer momento e
          com efeito imediato.
        </p>
        <p>
          12.2. Sendo assim, solicitamos que a revise com frequência para
          esclarecimentos e informações atualizadas.
        </p>
        <p>
          <br />
          <strong>Atualização: </strong> 20 de abril de 2023
        </p>
      </S.Text>
    </S.WrapperProposal>
  );
};

export default TermsPrivacyCard;
